const path = 'auth';

export const DATA_FETCHING = `${path}/DATA_FETCHING`;
export const DATA_FETCHED = `${path}/DATA_FETCHED`;
export const SYNC_GAME_DATA = `${path}/SYNC_GAME_DATA`;
export const ERROR_FETCHING = `${path}/ERROR_FETCHING`;
